import $http from './index.js'

//export const getData = $http.get('https://jsonplaceholder.typicode.com/posts')
//生产
//const BASEURL = 'http://175.178.81.204:80/server/lzufe-mba-app'
const BASEURL = 'https://lzufewpstest.cn/server/lzufe-mba-app'
//const BASEURL = 'http://192.168.1.63:9080/lzufe-mba-app'
//const BASEURL = 'http://192.168.43.114:9080/lzufe-mba-app'

export const login = (data) => {
    return $http.post(BASEURL + '/adminnService/login', data)
}

export const getUserListNoStatusCd = () => {
    return $http.post(BASEURL + '/user/getUserListNoStatusCd')
}

export const updateUserById = (data) => {
    return $http.post(BASEURL + '/user/updateUserById', data)
}

export const getRegisterStaticData = () => {
    return $http.post(BASEURL + '/staticdata/getRegisterStaticData',)
}

export const getRegionData = () => {
    return $http.post(BASEURL + '/staticdata/getRegionData',)
}

export const loginOut = (data) => {
    return $http.post(BASEURL + '/adminnService/loginOut', data)
}
export const searchApi = (data) => {
    return $http.post(BASEURL + '/adminnService/search', data)
}
export const approveUser = (data) => {
    return $http.post(BASEURL + '/adminnService/approveUser', data)
}
export const getAlumniEventsByNameAndStatus = (data) => {
    return $http.post(BASEURL + '/adminnService/getAlumniEventsByNameAndStatus', data)
}
export const addAlumniEvents = (data) => {
    return $http.post(BASEURL + '/adminnService/addAlumniEvents', data)
}
export const updateAlumniEvent = (data) => {
    return $http.post(BASEURL + '/adminnService/updateAlumniEvent', data)
}
export const getAlumniEventsPeople = (data) => {
    return $http.post(BASEURL + '/adminnService/getAlumniEventsPeople', data)
}
export const getMessageList = (data) => {
    return $http.post(BASEURL + '/adminnService/getMessageList', data)
}
export const replyMessage = (data) => {
    return $http.post(BASEURL + '/adminnService/replyMessage', data)
}
export const getUploadTempObj = () => {
    return $http.post(BASEURL + '/staticdata/getUploadTempObj')
}
export const getCourseList = (data) => {
    return $http.post(BASEURL + '/carousel/geiListByParm', data)
}
export const saveCourse = (data) => {
    return $http.post(BASEURL + '/carousel/addCarousel', data)
}
export const updateCarousel = (data) => {
    return $http.post(BASEURL + '/carousel/updateCarousel', data)
}
export const getOrgAdm = (data) => {
    return $http.post(BASEURL + '/branchOrganization/getOrgAdm', data)
}
export const addOrgAdm = (data) => {
    return $http.post(BASEURL + '/branchOrganization/addOrgAdm', data)
}
export const updateOrgAdm = (data) => {
    return $http.post(BASEURL + '/branchOrganization/updateOrgAdm', data)
}
export const getOrgMoreMemberAdm = (data) => {
    return $http.post(BASEURL + '/branchOrganization/getOrgMoreMemberAdm', data)
}

export const updateOrgMoreMemberAdm = (data) => {
    return $http.post(BASEURL + '/branchOrganization/updateOrgMoreMemberAdm', data)
}
export const approveMemberAdm = (data) => {
    return $http.post(BASEURL + '/branchOrganization/approveMemberAdm', data)
}

export const getAlumniResourceAdm = (data) => {
    return $http.post(BASEURL + '/alumniResourceService/getAlumniResourceAdm', data)
}

export const publishAlumniResource = (data) => {
    return $http.post(BASEURL + '/alumniResourceService/publishAlumniResource', data)
}

export const updateAlumniResource = (data) => {
    return $http.post(BASEURL + '/alumniResourceService/updateAlumniResource', data)
}
export const updateAlumniResourceState = (data) => {
    return $http.post(BASEURL + '/alumniResourceService/updateAlumniResourceState', data)
}
export const getAlumniCompanyListAdm = (data) => {
    return $http.post(BASEURL + '/alumnicompany/getAlumniCompanyListAdm', data)
}
export const addAlumniCompany = (data) => {
    return $http.post(BASEURL + '/alumnicompany/applyAddAlumniCompany', data)
}
export const updateStatusCdAlumniCompany = (data) => {
    return $http.post(BASEURL + '/alumnicompany/updateStatusCdAlumniCompany', data)
}
export const updateAlumniCompany = (data) => {
    return $http.post(BASEURL + '/alumnicompany/updateAlumniCompany', data)
}
export const getPageByParam = (data) => {
    return $http.post(BASEURL + '/alumniDonation/getPageByParam', data)
}
export const updateDonation = (data) => {
    return $http.post(BASEURL + '/alumniDonation/updateDonation', data)
}
export const updateStateDonation = (data) => {
    return $http.post(BASEURL + '/alumniDonation/updateStateDonation', data)
}
export const addDonation = (data) => {
    return $http.post(BASEURL + '/alumniDonation/addDonation', data)
}

export const addAlumniNews = (data) => {
    return $http.post(BASEURL + '/alumniNews/addAlumniNews', data)
}

export const updateAlumniNews = (data) => {
    return $http.post(BASEURL + '/alumniNews/updateAlumniNews', data)
}

export const updateStatusAlumniNews = (data) => {
    return $http.post(BASEURL + '/alumniNews/updateStatusAlumniNews', data)
}

export const getAlumniNews = (data) => {
    return $http.post(BASEURL + '/alumniNews/getAlumniNews', data)
}
export const getApplyResourceList = (data) => {
    return $http.post(BASEURL + '/apply/getApplyResourceList', data)
}
export const updateApplyResourceStatusCd = (data) => {
    return $http.post(BASEURL + '/apply/updateApplyResourceStatusCd', data)
}
